import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { DadosEmpresaService } from '@services/dados-empresa.service';
import { UsuarioPermissaoService } from '@services/usuario-permissao.service';
import { take } from 'rxjs/operators';
import { LoadingGenericoComponent } from '../../../components/loading-generico/loading-generico.component';
import { SuccessGenericoComponent } from '../../../components/success-generico/success-generico.component';
import { AlertDescartarAlteracoesComponent } from '../../../components/alert-descartar-alteracoes/alert-descartar-alteracoes.component';
import { ErrorGenericoComponent } from '../../../components/error-generico/error-generico.component';
import { SelectComponent } from '../../../components/select/select.component';
import { NgClass, AsyncPipe } from '@angular/common';
import { UsuarioPermissaoPipe } from '../../../pipes/usuario-permissao.pipe';

@Component({
    selector: 'app-dados-empresa-empresa',
    templateUrl: './dados-empresa-empresa.component.html',
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [LoadingGenericoComponent, SuccessGenericoComponent, AlertDescartarAlteracoesComponent, ErrorGenericoComponent, FormsModule, ReactiveFormsModule, SelectComponent, RouterLink, NgClass, AsyncPipe, UsuarioPermissaoPipe]
})
export class DadosEmpresaEmpresaComponent implements OnInit {
  public detalhesEmpresa: any = null;
  public formularioEmpresa: UntypedFormGroup;
  public ramosAtividadeApi: any;
  public idEmpresaLogada = localStorage.idEmpresaLogada;
  testeRamoAtividade='86'
  // VARIAVEIS DOS ALERTS
  public alertLoading = false;
  public alertSucesso = false;
  public alertError = false;
  public mensagemErro = '';
  public showAlertDescartarAlteracoes = false;

  constructor(
    private readonly service: DadosEmpresaService,
    private readonly formularioBuilder: UntypedFormBuilder,
    public usuarioPermissaoService: UsuarioPermissaoService,
    private readonly router : Router
  ) {}

  ngOnInit(): void {
    this.consultaRamosAtividades();
    this.consultaDadosEmpresa();
  }

  consultaRamosAtividades() {
    this.service.getRamosAtividades()
    .pipe(take(1))
    .subscribe({
      next: (response: any) => {
        if (response.status === 'OK') {
          this.ramosAtividadeApi = response.response;
        } else {
          this.ramosAtividadeApi = false;
        }
      },
      error: (error: any) => {
        this.ramosAtividadeApi = false;
        console.error(error);
      }
    });
  }

  consultaDadosEmpresa() {
    this.service.getDadosEmpresa(this.idEmpresaLogada)
    .pipe(take(1))
    .subscribe({
      next: (response: any) => {
        if (response.status === 'OK') {
          this.detalhesEmpresa = response.response;
          this.constroiFormularioEmpresa();
        } else {
          this.detalhesEmpresa = false;
        }
      },
      error: (error) => {
        this.detalhesEmpresa = false;
        console.error(error);
      }
    });
  }

  constroiFormularioEmpresa() {
    this.formularioEmpresa = this.formularioBuilder.group({
      nmRazaosEmp: [
        this.detalhesEmpresa.nmRazaosEmp,
        Validators.compose([Validators.required, Validators.maxLength(80)]),
      ],
      nmFantasEmp: [
        this.detalhesEmpresa.nmFantasEmp,
        Validators.compose([Validators.required, Validators.maxLength(30)]),
      ],
      idRamatiRat: [
        this.detalhesEmpresa.idRamatiRat,
        Validators.compose([Validators.required]),
      ],
      cdIeourgEmp: [this.detalhesEmpresa.cdIeourgEmp],
      cdImunicEmp: [this.detalhesEmpresa.cdImunicEmp],
    });
  }

  atualizarDadosEmpresa() {
    this.formularioEmpresa.value.idRamatiRat = Number.parseInt(
      this.formularioEmpresa.value.idRamatiRat
    );

    const objDadosEmpresa: any = {
      cdIeourgEmp: this.formularioEmpresa.value.cdIeourgEmp,
      cdImunicEmp: this.formularioEmpresa.value.cdImunicEmp,
      idRamatiRat: this.formularioEmpresa.value.idRamatiRat,
      nmFantasEmp: this.formularioEmpresa.value.nmFantasEmp,
      nmRazaosEmp: this.formularioEmpresa.value.nmRazaosEmp,
    };
    this.alertLoading = true;
    this.service
      .updateDadosEmpresa(this.idEmpresaLogada, objDadosEmpresa)
      .pipe(take(1))
      .subscribe({
        next: (response: any) => {
          this.alertLoading = false;
          if (response.status === 'OK') {
            this.alertSucesso = true;
            this.consultaDadosEmpresa();
          }
        },
        error: (erro: any) => {
          console.error(erro);
          this.alertLoading = false;
          this.alertError = true;
        }
      });
  }

  // Fechar o alerta de sucesso, clicando no botão OK
  fecharAlertSucesso(evento: string) {
    this.alertSucesso = false;
  }

  // Fechar o alerta de erro, clicando no botão OK
  fecharAlertError(evento: string) {
    this.alertError = false;
  }

  // Fechar o alerta de erro, clicando no botão OK
  showOrHideAlertDescartarAlteracoes() {
    this.showAlertDescartarAlteracoes = !this.showAlertDescartarAlteracoes;
  }

  descartarAlteracoes() {
    this.router.navigate(["/home"]);
  }
}
